import { userPlanAtom } from 'app/atoms';
import { isFreeTrialPlanCode, useMyActivePlans } from 'app/network/plan';
import { useAtomValue } from 'jotai';
import { isAnyWhiteLabel } from 'app/utils/helpers';

export function useHasPartagePlusSubscription() {
  const isAvailable = !isAnyWhiteLabel();
  const { data: activePlans } = useMyActivePlans({ enabled: isAvailable });
  const activePlansFromAtom = useAtomValue(userPlanAtom);
  const resolvedPlans = activePlans ?? activePlansFromAtom;
  if (!isAvailable || resolvedPlans === null) return undefined;

  const now = new Date();
  const currentPlan = resolvedPlans[0];
  return Boolean(
    currentPlan &&
    !isFreeTrialPlanCode(currentPlan.code.code) &&
    (!currentPlan.expiresAt || new Date(currentPlan.expiresAt).getTime() > now.getTime()),
  );
}
